import React from 'react';
import AwsAcc from './AWSACC';
import Eksns from './AKSNS';
import SqlDatabase from './SqlDatabase';
import PostgreSqlDatabase from './PostgreSqlDatabase';
import MySqlDatabase from './MySqlDatabase';
import OracleDatabase from './OracleDatabase';
import SNS from './SNS';
import Redis from './Redis';
import AwsS3 from './AWSS3';

const ConfigurationModal = (props) => {
    const { userSelectedResource, handleDrawerAction, order } = props;

    const component = () => {
        const { configurationComponentCode } = userSelectedResource;
        switch (configurationComponentCode) {
            case 'AWSACC': {
                return <AwsAcc resource={userSelectedResource} handleDrawerAction={handleDrawerAction} order={order} />;
            }
            case 'EKSNS': {
                return <Eksns resource={userSelectedResource} handleDrawerAction={handleDrawerAction} order={order} />;
            }
            case 'SQL': {
                return <SqlDatabase resource={userSelectedResource} handleDrawerAction={handleDrawerAction} order={order} />;
            }
            case 'POSTGRESQL': {
                return <PostgreSqlDatabase resource={userSelectedResource} handleDrawerAction={handleDrawerAction} />;
            }
            case 'MYSQL': {
                return <MySqlDatabase resource={userSelectedResource} handleDrawerAction={handleDrawerAction} />;
            }
            case 'ORACLE': {
                return <OracleDatabase resource={userSelectedResource} handleDrawerAction={handleDrawerAction} />;
            }
            case 'SNS': {
                return <SNS resource={userSelectedResource} handleDrawerAction={handleDrawerAction} />;
            }
            case 'REDIS': {
                return <Redis resource={userSelectedResource} handleDrawerAction={handleDrawerAction} />;
            }
            case 'S3': {
                return <AwsS3 resource={userSelectedResource} handleDrawerAction={handleDrawerAction} />;
            }
            default: {
                return null;
            }
        }
    };

    return component();
};

export default ConfigurationModal;
